import { lazy } from 'react'

export const BadHabitsFeedbackV1 = lazy(() => import('./BadHabitsFeedbackV1'))
